import { BrowserVendor } from "../../webchatcontroller/enums/BrowserVendor";
const REGEX_VERSION = "([\\d,.]+)";
const UNKNOWN_VERSION = "U";
let userAgent = undefined;
export const getUserAgent = () => {
  if (!userAgent) {
    userAgent = window.navigator.userAgent;
  }
  return userAgent;
};
const userAgentContainsString = searchString => {
  const userAgent = getUserAgent();
  return userAgent.indexOf(searchString) > -1;
};
const isEdge = () => {
  return userAgentContainsString(BrowserVendor.EDGE) || userAgentContainsString(BrowserVendor.EDGE_CHROMIUM);
};
export const isChromiumEdge = () => {
  return userAgentContainsString(BrowserVendor.EDGE_CHROMIUM) && !userAgentContainsString(BrowserVendor.EDGE);
};
const isOpera = () => {
  return userAgentContainsString("OPR/");
};
export const getBrowserName = () => {
  if (isOpera()) {
    return BrowserVendor.OPERA;
  }
  if (isEdge()) {
    return BrowserVendor.EDGE;
  }
  if (userAgentContainsString(BrowserVendor.CHROME)) {
    return BrowserVendor.CHROME;
  }
  if (userAgentContainsString(BrowserVendor.FIREFOX)) {
    return BrowserVendor.FIREFOX;
  }
  if (userAgentContainsString(BrowserVendor.SAFARI)) {
    return BrowserVendor.SAFARI;
  }
  return BrowserVendor.UNKNOWN;
};
export const getBrowserVersion = () => {
  let browserString = getBrowserName();
  const browserVersion = UNKNOWN_VERSION;
  let matches;
  if (browserString === BrowserVendor.SAFARI) {
    browserString = "Version";
  }

  // eslint-disable-next-line prefer-const
  matches = getUserAgent().match(new RegExp(browserString + "/" + REGEX_VERSION));
  if (matches) {
    return matches[1];
  }
  return browserVersion;
};